import React, { Component } from "react";

//Import CSS
import "./table.css";

//Import internal components
import TrackingTableLineDetail from "./tracking-table-line-details";
import TrackingOrderView from "./tracking-order-view";
import MarcaPropriaCta from "./marca-propria-cta";

//Import external components
import Moment from "moment";
import { ChevronDown, ChevronRight } from "react-bootstrap-icons";

class TrackingTableLine extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expandMode: null, // null | "details" | "order"
      status: "",
    };
    this.toggleDetails = this.toggleDetails.bind(this);
    this.toggleOrder = this.toggleOrder.bind(this);
  }

  componentDidMount() {
    const status = this.props.item.statusAtual;
    if (status.match(/faturado/gi)) {
      this.setState({ status: "is--green" });
    } else if (status.match(/cancelado/gi)) {
      this.setState({ status: "is--red" });
    } else {
      this.setState({ status: "is--blue" });
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.offset !== this.props.offset) {
      this.setState({ expandMode: null });
    }
  }

  toggleDetails() {
    this.setState(prevState => ({
      expandMode: prevState.expandMode === "details" ? null : "details",
    }));
  }

  toggleOrder() {
    this.setState(prevState => ({
      expandMode: prevState.expandMode === "order" ? null : "order",
    }));
  }

  render() {
    const { item } = this.props;
    const { expandMode } = this.state;
    const DetailsArrow = expandMode === "details" ? ChevronDown : ChevronRight;
    const OrderArrow = expandMode === "order" ? ChevronDown : ChevronRight;

    return (
      <tbody className={`tracking-main-table-body${expandMode ? " is--expanded" : ""}`} key={this.props.index}>
        <tr className={expandMode ? "tracking-row-has-expanded" : ""} data-result={this.props.index}>
          <td className={expandMode === "details" ? "tracking-tab-cell is--active" : "tracking-tab-cell"}>
            <button className={`tracking-action-btn${expandMode === "details" ? " is--active" : ""}`} onClick={this.toggleDetails}>
              <span>HISTÓRICO</span>
              <DetailsArrow size={14} />
            </button>
          </td>
          <td className={expandMode === "order" ? "tracking-tab-cell is--active" : "tracking-tab-cell"}>
            {this.props.detailOrder
              && item.tipoPedido !== "ATACADO"
              && item.tipoPedido !== "LENTE_PRONTA"
              && item.tipoPedido !== "LENTES_PRONTA"
              && (
                <button className={`tracking-action-btn${expandMode === "order" ? " is--active" : ""}`} onClick={this.toggleOrder}>
                  <span>DETALHES</span>
                  <OrderArrow size={14} />
                </button>
              )}
          </td>
          <td>{item.id}</td>
          <td className="hide-table-column hide-table-column-tablet">
            {item.idPedidoOtica !== "" && typeof item.idPedidoOtica !== "undefined" ? item.idPedidoOtica : "-"}
          </td>
          <td>{item.dataEntrada && Moment(item.dataEntrada).format("DD/MM/YYYY")}</td>
          <td className="hide-table-column">{item.dataEntregaPrevista && Moment(item.dataEntregaPrevista).format("DD/MM/YYYY")}</td>
          <td className="hide-table-column">
            <div className="tracking-main-table-status">
              <span className={`tracking-main-table-status-button ${this.state.status}`}>{item.statusAtual}</span>
            </div>
          </td>
        </tr>
        <tr className="hide-table-row" data-result={this.props.index}>
          <td className="status-row" colSpan="2">
            <div className="tracking-main-table-status">
              <span className={`tracking-main-table-status-button ${this.state.status}`}>{item.statusAtual}</span>
            </div>
          </td>
        </tr>
        <tr className="tracking-main-table-row-details">
          {expandMode === "details" && (
            <td colSpan="7" className="tracking-main-table-row-details-td" data-details={this.props.index}>
              <MarcaPropriaCta
                laboratorio_cnpj={this.props.laboratorio_cnpj}
                laboratorio_nome={this.props.laboratorio_nome}
                pedido_laboratotio={item.id}
              />
              <TrackingTableLineDetail
                laboratorio_cnpj={this.props.laboratorio_cnpj}
                detailOrder={this.props.detailOrder}
                otica_cnpj={this.props.otica_cnpj}
                pedido_laboratotio={item.id}
                pedido_otica={item.idPedidoOtica}
                nome_consumidor={item.consumidor ? item.consumidor.nome : ""}
                produto_direito={item.produto ? item.produto.olhoDireito : ""}
                produto_esquerdo={item.produto ? item.produto.olhoEsquerdo : ""}
                data_prevista={item.dataEntregaPrevista && Moment(item.dataEntregaPrevista).format("DD/MM/YYYY")}
                data_faturamento={item.dataFaturamento && Moment(item.dataFaturamento).format("DD/MM/YYYY")}
                nota_fiscal={item.notaFiscal ? item.notaFiscal.numero : ""}
                laboratorio_nome={this.props.laboratorio_nome}
                tipoPedido={item.tipoPedido ? item.tipoPedido : ""}
              />
            </td>
          )}
          {expandMode === "order" && (
            <td colSpan="7" className="tracking-main-table-row-details-td" data-details={this.props.index}>
              <MarcaPropriaCta
                laboratorio_cnpj={this.props.laboratorio_cnpj}
                laboratorio_nome={this.props.laboratorio_nome}
                pedido_laboratotio={item.id}
              />
              <TrackingOrderView
                laboratorio_cnpj={this.props.laboratorio_cnpj}
                laboratorio_nome={this.props.laboratorio_nome}
                otica_cnpj={this.props.otica_cnpj}
                pedido_id={item.id}
                pedido_otica={item.idPedidoOtica || ""}
                data_entrada={item.dataEntrada}
                data_prevista={item.dataEntregaPrevista && Moment(item.dataEntregaPrevista).format("DD/MM/YYYY")}
                status_atual={item.statusAtual || ""}
              />
            </td>
          )}
        </tr>
      </tbody>
    );
  }
}

export default TrackingTableLine;
